/**
 * * @module component/faq.js
 */
import regeneratorRuntime from "regenerator-runtime";
import backbone from "backbone";
import $ from "jquery";
import _ from "underscore";
import Bootstrap from "bootstrap";

const Faq = Backbone.View.extend({
  el: $(document),

  events: {
  },

  initialize: function () {
    this.render();
  },

  manageFaq: function(){
    $(".faq-details").on("show.bs.collapse", function (e) {
      $(e.target).prev().addClass("open");
      $(e.target).prev().parent().addClass("open");
    });
    $(".faq-details").on("hide.bs.collapse", function (e) {
      $(e.target).prev().removeClass("open");
      $(e.target).prev().parent().removeClass("open");
    });
  },

  render: function () {
    this.manageFaq();
  },
});

export default Faq;
